import React, { useEffect, useState } from "react";
import { supabase } from "../../supabase-client";
import { useLocation, useNavigate } from "react-router-dom";

const Failure = () => {
   const [paymentData, setPaymentData] = useState(null);
   const [loading, setLoading] = useState(true);
   const [isSaving, setIsSaving] = useState(false);
   const location = useLocation();
   const navigate = useNavigate();

   useEffect(() => {
      // Get URL parameters
      const urlParams = new URLSearchParams(location.search);

      // Extract common MercadoPago failure parameters
      const failureData = {
         pedido: urlParams.get("pedido") || 0,
         preference_id: urlParams.get("preference_id"),
         cotizacion_id: urlParams.get("cotizacion_id") || 0,
         // collection_id: urlParams.get("collection_id"), // Payment ID
         // collection_status: urlParams.get("collection_status"), // Payment status
         // payment_id: urlParams.get("payment_id"), // Alternative payment ID
         // status: urlParams.get("status"), // Status
         // external_reference: urlParams.get("external_reference"), // Your order reference
         // payment_type: urlParams.get("payment_type"), // Payment method type
         // merchant_order_id: urlParams.get("merchant_order_id"), // Merchant order ID
         // site_id: urlParams.get("site_id"), // Site ID
         // processing_mode: urlParams.get("processing_mode"), // Processing mode
         // merchant_account_id: urlParams.get("merchant_account_id"), // Merchant account
         // Custom parameters
         // id: urlParams.get("id"), // Your custom ID parameter
         // orderId: urlParams.get("orderId"), // Custom order ID
         // userId: urlParams.get("userId"), // Custom user ID
      };

      console.log("Payment Failure Data:", failureData);
      console.log("🔗 Full URL:", window.location.href);

      setPaymentData(failureData);
      setLoading(false);

      // Optional: Send failure data to your backend for logging
      logPaymentFailure(failureData);
   }, [location]);

   const logPaymentFailure = async (data) => {
      // 👈 Prevent double execution
      if (isSaving) return;
      setIsSaving(true);
      try {
         // const editRecord = {
         //    mercadopago_id: data.preference_id,
         //    pedido_id: data.pedido,
         //    cotizacion_id: data.cotizacion_id,
         // };
         // console.log("editRecord: ", editRecord);
         const { datos, error } = await supabase.from("mercado_pago").insert([
            {
               estado: "Failure",
               mercadopago_id: data.preference_id,
               pedido_id: data.pedido,
               cotizacion_id: data.cotizacion_id,
            },
         ]);

         // Log the failure to your backend

         if (error) {
            console.error("Failed to log payment failure");
         } else {
            console.log("Payment failure logged successfully");
         }
      } catch (error) {
         console.error("Error logging payment failure:", error);
      }
   };

   const handleGoHome = () => {
      navigate("/");
   };

   if (loading) {
      return (
         <div className="flex justify-center items-center min-h-screen">
            <div className="text-center">
               <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-500 mx-auto mb-4"></div>
               <p>Loading payment information...</p>
            </div>
         </div>
      );
   }
   const grabarCancelacion = async (id) => {
      const { data: newOrder, error: orderError } = await supabase
         .from("pedidos")
         .update({
            estado: "cancelado",
         })
         .eq("id", id);
   };
   const liberarObrasBulk = async (pedidoId) => {
      try {
         // Get the pedido
         const { data: pedido, error: pedidoError } = await supabase
            .from("pedidos")
            .select("obras")
            .eq("id", pedidoId)
            .single();

         if (pedidoError) {
            console.error("Error fetching pedido:", pedidoError);
            return;
         }

         // Parse obra IDs
         console.log("pedido: ", pedido);
         let obraIds = [];

         if (pedido.obras) {
            if (typeof pedido.obras === "string") {
               // If it's a JSON string, parse it first
               try {
                  const parsedObras = JSON.parse(pedido.obras);
                  if (Array.isArray(parsedObras)) {
                     // Extract just the id from each obra object
                     obraIds = parsedObras.map((obra) => obra.id);
                  }
               } catch (e) {
                  console.error("Error parsing obras JSON:", e);
                  return;
               }
            } else if (Array.isArray(pedido.obras)) {
               // If it's already an array, extract IDs
               obraIds = pedido.obras.map((obra) => obra.id);
            }
         }

         console.log("obraIds: ", obraIds);
         if (obraIds && obraIds.length > 0) {
            // Bulk update using 'in' operator
            const { error: releaseError } = await supabase
               .from("obras")
               .update({ estado: 2 })
               .in("id", obraIds);

            if (releaseError) {
               console.error("Error releasing obras:", releaseError);
            } else {
               console.log(
                  `✅ Released ${obraIds.length} obras: ${obraIds.join(", ")}`
               );
            }
         }
      } catch (error) {
         console.error("Error in liberarObrasBulk:", error);
      }
   };

   const insertPedidosHist = async (id) => {
      console.log("insertPedidosHist: ", id);
      try {
         const { error } = await supabase.from("pedidos_hist").insert({
            pedido_id: id,
            estado: "cancelado", // "Canceled" status
         });
      } catch (error) {
         console.error("Error in insertPedidosHist:", error);
      }
   };
   const updateCotizacion = async (id) => {
      console.log("updateCotizacion: ", id);
      try {
         const { error } = await supabase.from("cotizacion_hist").insert({
            cotizacion_id: id,
            estado: "cancelado", // "Canceled" status
         });

         // Borro informacion de pago e cotizacion_pagos
         const { error: deletePagoError } = await supabase
            .from("cotizacion_pagos")
            .delete()
            .eq("cotizacion_id", id);
            
         // Update Cotizacion seteo estado a cotizado
         const { error: updateCotizacionError } = await supabase
            .from("cotizacion")
            .update({ estado: "cotizado" })
            .eq("id", id);
      } catch (error) {
         console.error("Error in updateCotizacion:", error);
      }
   };
   if (paymentData) {
      console.log("paymentData: ", paymentData);
      if (paymentData.pedido > 0) {
         insertPedidosHist(paymentData.pedido);
         liberarObrasBulk(paymentData.pedido);
         grabarCancelacion(paymentData.pedido);
      } else {
         updateCotizacion(paymentData.cotizacion_id);
      }
   }

   return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
         <div className="max-w-md w-full space-y-8">
            <div className="text-center">
               {/* Error Icon */}
               <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-6">
                  <svg
                     className="h-8 w-8 text-red-600"
                     fill="none"
                     viewBox="0 0 24 24"
                     stroke="currentColor"
                  >
                     <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                     />
                  </svg>
               </div>

               <h1 className="text-3xl font-bold text-gray-900 mb-4">
                  PAGO Cancelado
               </h1>

               <p className="text-lg text-gray-600 mb-8">
                  Su pago no pudo ser procesado.
               </p>

               {/* Payment Details */}
               {paymentData && (
                  <div className="bg-white shadow-md rounded-lg p-6 mb-8 text-left">
                     {paymentData.pedido && (
                        <>
                           <h3 className="text-lg font-semibold text-gray-800 mb-4">
                              Pago de Obra:
                           </h3>

                           <div className="mb-2">
                              <span className="font-medium text-gray-600">
                                 ID:
                              </span>
                              <span className="ml-2 text-gray-800">
                                 {paymentData.pedido}
                              </span>
                           </div>
                        </>
                     )}
                     {paymentData.cotizacion_id !== "null" && (
                        <>
                           <h3 className="text-lg font-semibold text-gray-800 mb-4">
                              Cotizacion
                           </h3>

                           <div className="mb-2">
                              <span className="font-medium text-gray-600">
                                 ID:
                              </span>
                              <span className="ml-2 text-gray-800">
                                 {paymentData.cotizacion_id}
                              </span>
                           </div>
                        </>
                     )}

                     <div className="mb-2">
                        <span className="font-medium text-gray-600">
                           Payment ID:
                        </span>
                        <span className="ml-2 text-gray-800">
                           {paymentData.preference_id}
                        </span>
                     </div>

                     {paymentData.status && (
                        <div className="mb-2">
                           <span className="font-medium text-gray-600">
                              Status:
                           </span>
                           <span className="ml-2 text-red-600 font-medium">
                              Proceso de Pago Fallido
                           </span>
                        </div>
                     )}
                  </div>
               )}

               {/* Action Buttons */}
               <div className="space-y-4">
                  <button
                     onClick={handleGoHome}
                     className="w-full bg-gray-500 hover:bg-gray-600 text-white font-bold py-3 px-6 rounded-lg transition-colors duration-200"
                  >
                     Volver a Inicio
                  </button>
               </div>

               {/* Support Information */}
               <div className="mt-8 p-4 bg-blue-50 rounded-lg">
                  <h4 className="font-semibold text-blue-800 mb-2">
                     Need Help?
                  </h4>
                  <p className="text-sm text-blue-600">
                     If you continue having issues, please contact our support
                     team with the payment details above.
                  </p>
                  <div className="mt-2 text-sm text-blue-600">
                     <p>Email: support@diegocurutchet.com</p>
                     <p>Phone: +54 123 456 7890</p>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default Failure;
